export const ADD_INLINE_MESSAGE = 'ADD_INLINE_MESSAGE';
export const ADD_SINGLE_INLINE_MESSAGE = 'ADD_SINGLE_INLINE_MESSAGE';
export const REMOVE_INLINE_MESSAGE = 'REMOVE_INLINE_MESSAGE';
export const CLEAR_INLINE_MESSAGES = 'CLEAR_INLINE_MESSAGES';

export const ADD_GROWL_MESSAGE = 'ADD_GROWL_MESSAGE';
export const REMOVE_GROWL_MESSAGE = 'REMOVE_GROWL_MESSAGE';
export const CLEAR_GROWL_MESSAGES = 'CLEAR_GROWL_MESSAGES';



// WEBPACK FOOTER //
// src/modules/messages/constants/messages_constants.js